import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac9244c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "VATPayments" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "top-content" }
const _hoisted_4 = {
  class: "flex-row-centered selection-form",
  style: {"align-items":"flex-end"}
}
const _hoisted_5 = { class: "flex-col-centered selection" }

import { ref, onMounted } from 'vue';
import { marketSelection as market } from "@/services/helpers/Helper";
import PeriodSelector from '@/components/PeriodSelector.vue';
import NoWrapText from '@/components/NoWrapText.vue';
import LedgerTransaction from '@/models/Ledgering/LedgerTransaction';
import CancellablePromise, {PromiseCancelledError} from '@/types/CancellablePromise';
import Table, { ITableExpose } from '@/components/TablePersistentChecking.vue';
import ILedgerTransactions from '@/Interfaces/Ledgering/ILedgerTransactions';
import DatePeriod from '@/types/DatePeriod';
import PaginatedCache from '@/types/PaginatedCache';
import MarketSelector from '@/components/MarketSelector.vue';
import LedgerTransactionForm from '@/components/Ledger/LedgerTransactionForm.vue';
import { ledgerTransactions } from '@/services/network';
import useSpinnerPopup from '@/services/composables/SpinnerPopup';
import DbTableCsvHelper from '@/services/helpers/DbTableCsvHelper';
import DateTimeFileName from '@/types/DateTimeFileName';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';
import IFilter from '@/Interfaces/IFilter';

type Filter = IFilter<LedgerTransaction>;


export default /*#__PURE__*/_defineComponent({
  __name: 'LedgerTransactions',
  setup(__props) {

const showingPostForm = ref(false);
const errGet = ref();
const errDownload = ref();
const period = ref<DatePeriod>(new DatePeriod(null));
const table = ref<ITableExpose<LedgerTransaction>>();
const createForm = ref<InstanceType<typeof LedgerTransactionForm>>();
const rows = ref<LedgerTransaction[]>([]);
const cache = new PaginatedCache(loadPaginatedData);

onMounted(() => {document.title='Ledger Transactions - UV'});
const cols: (keyof LedgerTransaction)[] = [
    'paymentId',
    'transactionId',
    'accountId',
    'valueDate',
    'targetDate',
    'amount',
    'market',
    'currency',
    'paymentAdviceReference',
    'paymentReference',
    'transferTypeId',
    'itemType',
    'itemCategory',
    'categoryPeriod',
    'invoiceId',
    'creditNoteId',
    'contractId',
    'assignedTo',
    'transferInfo',
];
let lastSort = [] as number[];
let lastOrder = [] as (-1|1)[];
let lastFilter: Filter = {};
// need to move following code to a composable
function onChangeFilter() {
    cache.reset();
    table.value?.LoadData();
}
async function loadPaginatedData(offset: number, count: number, bookmark?: number) {
    const sort = lastSort.map(x=>cols[x]);
    const res = await ledgerTransactions.get({
        market: market.value
    }, {
        sort: sort.length > 0 ? sort : undefined,
        order: sort.length > 0 ? lastOrder : undefined,
        offset,
        count,
        period: period.value.isValid()? period.value : undefined,
        bookmark,
        ...lastFilter
    });
    const data = res.data as ILedgerTransactions;
    return {
        data: data.transactions.map(t=>new LedgerTransaction(t)),
        bookmark: data.bookmark,
        totalCount: data.totalCount,
    }
}
function getSortedEntries(obj: NonNullable<unknown>) {
    return Object.entries(obj).sort(([k1,v1],[k2,v2])=>k1.localeCompare(k2));
}
async function loadOrResetCache(offset: number, count: number, sort: number[] = [], order: (-1|1)[] = [], filter?: Filter) {
    filter = filter ?? {}
    if (JSON.stringify(lastSort) !== JSON.stringify(sort) ||
        JSON.stringify(lastOrder) !== JSON.stringify(order) ||
        JSON.stringify(getSortedEntries(filter)) !== JSON.stringify(getSortedEntries(lastFilter))
    ) {
        cache.reset();
        lastSort = Array.from(sort);
        lastOrder = Array.from(order);
        lastFilter = Object.assign({}, filter);
    }
    return await cache.load(offset, count);
}
function loadDataAsync(offset: number, count: number, sort: number[] = [], order: (-1|1)[] = [], filter?: Filter) {
    errGet.value = undefined;
    const promise = loadOrResetCache(offset,count,sort,order,filter);
    return new CancellablePromise(promise).then(
        (res)=>rows.value = res,
        (error)=> {
            if (!(error instanceof PromiseCancelledError)) {
                errGet.value = error;
                useNotifierWithErrFormatter().error({
                    errorType: 'Getting Ledger Transactions',
                    error
                })
            }
        }
    ) as CancellablePromise;
}
function onPostSuccess() {
    onChangeFilter();
}
async function exportCsv() {
    const closeSpinner = useSpinnerPopup().show();
    try {
        errDownload.value = undefined;
        const task = ledgerTransactions.get();
        const dlTime = new DateTimeFileName();
        const res = await task;
        DbTableCsvHelper.generateCsvDownload(res.data.transactions, `LedgerTransactions${dlTime}.csv`);
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: 'Downloading Ledger Transaction Table',
            error
        });
    }
    closeSpinner();
}
function showCreateFormAndAssignTemplate(x: LedgerTransaction) {
    createForm.value?.assignTemplate(x);
    showingPostForm.value = true;
}
function onSelectorUpdate() {
    onChangeFilter();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LedgerTransactionForm, {
      ref_key: "createForm",
      ref: createForm,
      modelValue: showingPostForm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showingPostForm).value = $event)),
      onSubmit: onPostSuccess
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MarketSelector, {
            onChange: onSelectorUpdate,
            enableSE: ""
          }),
          _createVNode(PeriodSelector, {
            modelValue: period.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((period).value = $event)),
              onSelectorUpdate
            ],
            showTitle: "",
            hasNullSelector: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "centre-button",
              style: {"font-size":"1.8rem","padding":"0"},
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showingPostForm.value = true))
            }, " + ")
          ]),
          _createElementVNode("div", { class: "flex-col-centered selection" }, [
            _createElementVNode("button", {
              class: "centre-button",
              type: "button",
              onClick: exportCsv
            }, " Export Full Table ")
          ])
        ])
      ]),
      _createVNode(Table, {
        ref_key: "table",
        ref: table,
        Rows: rows.value,
        Cols: cols,
        NumRecords: _unref(cache).getTotal(),
        LoadDataCallBack: loadDataAsync,
        RowClickedCallBack: showCreateFormAndAssignTemplate,
        HasError: !!errGet.value,
        ShowHeaderWhileLoading: "",
        SplitColKeys: ""
      }, {
        valueDate: _withCtx((props) => [
          _createVNode(NoWrapText, {
            val: props.value.valueDate
          }, null, 8, ["val"])
        ]),
        targetDate: _withCtx((props) => [
          _createVNode(NoWrapText, {
            val: props.value.targetDate
          }, null, 8, ["val"])
        ]),
        categoryPeriod: _withCtx((props) => [
          _createVNode(NoWrapText, {
            val: props.value.categoryPeriod
          }, null, 8, ["val"])
        ]),
        _: 1
      }, 8, ["Rows", "NumRecords", "HasError"])
    ])
  ]))
}
}

})